export default {
  title: 'Mesas',
  count_one: '{{count}} mesa',
  count_other: '{{count}} mesas',
  filtered_count: '{{shown}} de {{count}} mesas',
  intro:
    'Cada mesa tem a sua própria ligação e código QR. Os clientes que o digitalizarem fazem o pedido para essa mesa, e a mesa aparece em todos os pedidos.',
  migrated: {
    title: 'O serviço de quarto/mesa passou a Pedidos à mesa',
    description:
      'Adicionámos uma mesa para cada um dos seus locais, com o nome do local, para que os clientes possam continuar a pedir. Altere os nomes para corresponderem às suas mesas ou adicione mais.',
  },
  add: {
    label: 'Adicionar mesa',
    placeholder: 'ex.: 7, 1A ou Esplanada 2',
    button: 'Adicionar mesa',
  },
  errors: {
    empty: 'Introduza o nome da mesa.',
    duplicate: 'Já existe uma mesa com o nome “{{name}}”.',
    too_long: 'O nome de uma mesa pode ter até {{max}} caracteres.',
  },
  columns: {
    order: 'Ordem',
    table: 'Mesa e ligação',
    on: 'Ativa',
    copy: 'Copiar ligação',
    qr: 'Código QR',
    actions: 'Ações',
  },
  switch: {
    on: 'Ativa',
    off: 'Inativa',
  },
  buttons: {
    copy: 'Copiar ligação',
    copied: 'Copiado',
    download_qr: 'Transferir código QR',
    qr_short: 'Código QR',
    rename: 'Mudar o nome',
    delete: 'Eliminar',
    save: 'Guardar',
    cancel: 'Cancelar',
  },
  aria: {
    move: 'Mover {{name}} (teclas de seta)',
    switch: '{{name}} ativa',
    copy: 'Copiar ligação de {{name}}',
    copied: 'Ligação copiada',
    download_qr: 'Transferir código QR de {{name}}',
    rename: 'Mudar o nome de {{name}}',
    delete: 'Eliminar {{name}}',
    more: 'Mais opções para {{name}}',
    new_name: 'Novo nome para {{name}}',
  },
  tooltips: {
    move: 'Arraste para reordenar',
    move_disabled: 'Limpe a pesquisa para reordenar',
  },
  rename_hint: 'A ligação e o código QR mantêm-se.',
  no_link: 'Ainda sem endereço da loja',
  search: {
    placeholder: 'Pesquisar mesas',
    no_results: 'Nenhuma mesa com o nome “{{text}}”.',
  },
  load_failed: {
    title: 'Não foi possível carregar as mesas.',
    retry: 'Tentar novamente',
  },
  empty: {
    title: 'Ainda sem mesas',
    text: 'Adicione as suas mesas acima para obter uma ligação e um código QR para cada uma. Os clientes não podem pedir à mesa até adicionar uma.',
  },
  delete: {
    title: 'Eliminar a mesa “{{name}}”?',
    warning:
      'Os códigos QR impressos desta mesa deixarão de funcionar. Os clientes que digitalizarem um serão convidados a falar com o pessoal.',
    softer: 'Para parar os pedidos nesta mesa durante algum tempo, desative-a.',
    confirm: 'Eliminar mesa',
    cancel: 'Cancelar',
  },
  announcements: {
    moved: '“{{name}}” movida para a posição {{position}} de {{count}}.',
    instructions: 'Para mover uma mesa, selecione a sua pega e prima a seta para cima ou para baixo.',
  },
  qr_image: {
    table: 'Mesa',
  },
  toasts: {
    added: 'Mesa “{{name}}” adicionada',
    renamed: '“{{old}}” renomeada para “{{name}}”',
    deleted: 'Mesa “{{name}}” eliminada',
    switched_on: '“{{name}}” ativada',
    switched_off: '“{{name}}” desativada',
    failed_to_save: 'Não foi guardado. Tente novamente.',
    failed_to_reorder: 'A nova ordem não foi guardada. Tente novamente.',
    failed_to_download_qr: 'Não foi possível guardar o código QR. Tente novamente.',
    copy_failed: 'Não foi possível copiar a ligação. Tente novamente.',
  },
};
